module.exports = __webpack_public_path__ + "static/img/bg.baf55ef2.png";